import { useDispatch, useSelector } from 'react-redux';

import { OperatorsActions } from '../../store/reducers/operators';
import RadioGroup from '../common/RadioGroup';
import Radio from '../common/Radio';

import styles from './OperatorComponents.module.scss';
import {
  BUSINESS_MODEL_DROPSHIP,
  BUSINESS_MODEL_MARKETPLACE,
  BusinessModelDisplayName,
} from '../../constants/operators';

export function OperatorBusinessModelSelector() {
  const dispatch = useDispatch();
  const { businessModel } = useSelector((state) => state.operators);
  const { supplier } = useSelector((state) => state.activation);

  const setBusinessModel = (businessModel) => {
    dispatch({ type: OperatorsActions.businessModel, payload: businessModel });
  };

  return (
    <div className={styles.businessModel}>
      <h4>Assign the relevant business model for {supplier.name}</h4>
      <RadioGroup name="business-model" onChange={(value) => setBusinessModel(value)} selectedvalue={businessModel}>
        <Radio id="marketplace" value={BUSINESS_MODEL_MARKETPLACE} label={BusinessModelDisplayName.marketplace} />
        <Radio id="dropship" value={BUSINESS_MODEL_DROPSHIP} label={BusinessModelDisplayName.dropship} />
      </RadioGroup>
    </div>
  );
}
